
      ;(async () => {
        try {
          const response = await fetch('https://staging-api.superscout.world/version')
          const data = await response.json()
          const currentVersion = localStorage.getItem('version')
          if (currentVersion !== String(data.version)) {
            localStorage.setItem('version', data.version)
            window.location.reload()
          }
        } catch (err) {
          console.error('Version check failed:', err)
        }

        //Hide the loading div before loading the main app
        //Load the actual app after version check
        import('/src/main.js')
          .then(() => {
            // Disable loading after script is loaded
            document.getElementById('loading').style.display = 'none'
          })
          .catch((error) => {
            console.error('Error loading script:', error)
            document.getElementById('loading').style.display = 'none'
          })
      })()
    